import {QPost} from "./pfetch";
import root from "window-or-global";
const getCitySpecificCategoryId = (cityId, categoryGlobalId, categoryId) => {
    return new Promise(
        function (resolve, reject) {
            const ajaxHost =  "https://www.quikr.com";
            const params = {
                cityId: cityId
            };

            if(typeof categoryGlobalId !== 'undefined' && categoryGlobalId){
                params['categoryGlobalId'] = categoryGlobalId;
            }

            if(typeof categoryId !== 'undefined' && categoryId){
                params['categoryId'] = categoryId;
            }

            QPost(ajaxHost + '/escrow/Category/getCitySpecificCategoryId?aj=1', params).then((response) => {
                if(response.hasOwnProperty('status') && response.status === 'success'){
                    resolve(response.id);
                }else{
                    reject(response.errorMessage?response.errorMessage:'Something went wrong');
                }
            }).catch((err) => {
                reject('Something went wrong');
            });
        }
    );
};

const searchCityCallbackForSnb = (cityId, cityName, globalId, match) => {
    cityId = cityId*1;
    const isAllIndia = (cityId === 0 || cityId === 1);
    const pageUrl = match.url;
    const matches = pageUrl.match(/[w|x|y|z](\d+)([a-zA-Z]+)/);

    getCitySpecificCategoryId(cityId, globalId).then((categoryId) => {
        let searchMatches = pageUrl.match(/(x|z)(\d+)/);
        let isSearchUrl = (searchMatches && searchMatches.length);
        let slugParams = match.params.slug.split('+');
        let slugParamsLength = slugParams.length;
        if(isAllIndia){
            slugParams[slugParamsLength - 1] = (isSearchUrl?'z':'y')+categoryId+matches[2];
            slugParams[slugParamsLength - 2] = 'India';
        }else{
            slugParams[slugParamsLength - 1] = (isSearchUrl?'x':'w')+categoryId+matches[2];
            slugParams[slugParamsLength - 2] = cityName;
        }
        root.location.href = root.location.origin + '/' + match.params.type + '/' + slugParams.join('+') + root.location.search;
    }).catch((err) => {
        console.log(err);
    });
};

const searchCityCallbackForCategory = (cityId, cityName, globalId, match) => {
    cityId = cityId*1;
    cityName = cityName.toLowerCase();
    const isAllIndia = (cityId === 0 || cityId === 1);
    const pageUrl = match.url;
    const matches = pageUrl.match(/[gId|cId](\d+)/);

    getCitySpecificCategoryId(cityId, globalId).then((categoryId) => {
        let slugParams = match.params.slug.split('+');
        let slugParamsLength = slugParams.length;
        if(isAllIndia){
            slugParams[slugParamsLength - 2] = 'gId'+escrowCategoriesMap[match.params.type];
            slugParams.splice(slugParamsLength - 1, 1);
        }else{
            if(slugParamsLength === 1){
                slugParams[0] = cityName;
                slugParams[1] = 'cId'+categoryId;
            }else{
                slugParams[slugParamsLength - 2] = cityName;
                slugParams[slugParamsLength - 1] = 'cId'+categoryId;
            }
        }
        root.location.href = root.location.origin + '/' + match.params.type + '/' + slugParams.join('+') + root.location.search;
    }).catch((err) => {
        console.log(err);
    });
};

const searchCityCallbackForCertified = (cityId, cityName, globalId, match) => {
    cityId = cityId*1;
    const isAllIndia = (cityId === 0 || cityId === 1);

    let slugParams = match.params.slug.split('+');
    const slugParamsLength = slugParams.length;
    if(slugParamsLength){
        if(isAllIndia){
            if(slugParamsLength > 1){
                slugParams.splice(slugParamsLength - 1, 1);
            }
        }else{
            if(slugParamsLength > 1){
                slugParams[slugParamsLength - 1] = cityName.toLowerCase();
            }else{
                slugParams[slugParamsLength] = cityName.toLowerCase();
            }
        }
    }
    root.location.href = root.location.origin + '/' + match.params.type + '/' + slugParams.join('+') + root.location.search;
};

const searchCityCallbackForAssured = (cityId, cityName, globalId, match) => {
    cityId = cityId*1;
    const isAllIndia = (cityId === 0 || cityId === 1);

    let slugParams = match.params.slug.split('+');
    const slugParamsLength = slugParams.length;
    if(slugParamsLength){
        if(isAllIndia){
            if(slugParamsLength > 1){
                slugParams.splice(slugParamsLength - 1, 1);
            }
        }else{
            if(slugParamsLength > 1){
                slugParams[slugParamsLength - 1] = cityName.toLowerCase();
            }else{
                slugParams[slugParamsLength] = cityName.toLowerCase();
            }
        }
    }
    root.location.href = root.location.origin + '/' + slugParams.join('+') + root.location.search;
};

export {getCitySpecificCategoryId, searchCityCallbackForSnb, searchCityCallbackForCategory, searchCityCallbackForCertified, searchCityCallbackForAssured }


// WEBPACK FOOTER //
// ../q-goods/src/common/cityChangeHelper.jsx